import { Box, Image } from "@chakra-ui/react";
import { ImageSkeleton } from "../../../../components/loading/ImageSkeleton";

interface CreatorMiniCardProps {
  name: string;
  avatarUrl?: string;
  onClick: () => void;
}

export function CreatorMiniCard({ name, avatarUrl, onClick }: CreatorMiniCardProps) {
  return (
    <Box
      flexShrink={0}
      w="100px"
      h="100px"
      borderRadius="8px"
      overflow="hidden"
      bg="transparent.white.05"
      cursor="pointer"
      onClick={onClick}
      transition="opacity 0.15s ease"
      _hover={{ opacity: 0.85 }}
    >
      {avatarUrl ? (
        <Image src={avatarUrl} alt={name} w="full" h="full" objectFit="cover" />
      ) : (
        <ImageSkeleton w="full" h="full" borderRadius="8px" />
      )}
    </Box>
  );
}
